import React from "react";
import { Tooltip, IconButton, Backdrop, CircularProgress } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useSnackbar } from "notistack";
import getHiddenFields from "../helpers/schemas/getHiddenFields";
import ExportDialog from "./ExportDialog";
import { saveToFirestore } from "../helpers/saveToFirestore";
import { getSchema } from "../helpers/schemas/getSchema";
import getAllPropertyNames from "../helpers/getAllPropertyNames";
import { exportIssue } from "../helpers/exports/exportIssue";
import { exportEquipment } from "../helpers/exports/exportEquipment";
import { exportObservation } from "../helpers/exports/exportObservation";
import getProjectHiddenFields from "../helpers/schemas/getProjectHiddenFields";
import { exportChecklist } from "../helpers/exports/exportChecklist";

export default function ExportButton(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [exportDialogOpen, setExportDialogOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [templateName, setTemplateName] = React.useState("Default");
  const [newTemplateName, setNewTemplateName] = React.useState("Default");
  const [exportTemplates, setExportTemplates] = React.useState(
    props.project.ExportTemplates.filter(
      (t) => t.type === props.exportTableName,
    )[0]?.sections || [],
  );
  const [reportSections, setReportSections] = React.useState([]);
  const [project] = React.useState(props.project);

  const onCloseExportDialog = () => {
    setExportDialogOpen(false);
    setTemplateName("Default");
  };

  const getSectionFields = (sectionName, tableArry) => {
    var order = 0;
    var fds = [];
    const excludedFields =
      sectionName === "projects" ? getProjectHiddenFields() : getHiddenFields();
    var fields = getSchema(sectionName).map((s) => s.name);
    var allExisting = getAllPropertyNames(tableArry);
    const allFds = [...new Set([...fields, ...allExisting])];

    allFds.forEach((fd) => {
      if (!excludedFields.includes(fd)) {
        const sampleValue =
          tableArry.find((f) => f[fd].length > 0)?.[fd] || "*No Data saved*";
        fds.push({
          name: fd,
          sample: sampleValue,
          order: order,
          checked: true,
        });
        order += 1;
      }
    });

    if (
      sectionName !== "projects" &&
      sectionName !== "contact" &&
      sectionName !== "checklist"
    ) {
      fds.push({
        name: "Show Pictures?",
        sample: "",
        order: order,
        checked: true,
      });
      // fds.push({
      //   name: "Show Files?",
      //   sample: "",
      //   order: order + 1,
      //   checked: true,
      // });
    }

    return fds;
  };

  const onExportClick = () => {
    // check for existing templates
    const issuesTemplates =
      project.ExportTemplates.filter((t) => t.type === props.exportTableName) ||
      [];
    if (issuesTemplates.length > 0) {
      setExportTemplates(issuesTemplates);
    } else {
      setExportTemplates([]);
    }

    //populate template data
    var sections = [];
    const sectionFds0 = getSectionFields("projects", [project]);
    sections.push({ isChecked: true, name: "Project", fields: sectionFds0 });
    const section0ss = getSectionFields("contact", project.Contacts);
    sections.push({ isChecked: true, name: "Contacts", fields: section0ss });
    if (props.exportTableName === "Issue") {
      const sectionFds = getSectionFields("issue", [props.issue]);
      sections.push({ isChecked: true, name: "Issue", fields: sectionFds });
      if (project.Comments.filter((c) => c.issue_id.length > 0).length > 0) {
        const sectionFds2 = getSectionFields(
          "comment",
          project.Comments.filter((c) => c.issue_id.length > 0),
        );
        sections.push({
          isChecked: true,
          name: "Comments",
          fields: sectionFds2,
        });
      }
    } else if (props.exportTableName === "Checklist") {
      const sectionFds = getSectionFields("checklist", [props.checklist]);
      sections.push({ isChecked: true, name: "Checklist", fields: sectionFds });
      if (
        project.Comments.filter((c) => c.checklist_id.length > 0).length > 0
      ) {
        const sectionFds2 = getSectionFields(
          "comment",
          project.Comments.filter((c) => c.checklist_id.length > 0),
        );
        sections.push({
          isChecked: true,
          name: "Checklist Comments",
          fields: sectionFds2,
        });
      }
    } else if (props.exportTableName === "Equipment") {
      const sectionFds = getSectionFields("equipment", [props.equipment]);
      sections.push({ isChecked: true, name: "Equipment", fields: sectionFds });
      if (
        project.Comments.filter((c) => c.equipment_id.length > 0).length > 0
      ) {
        const sectionFds2 = getSectionFields(
          "comment",
          project.Comments.filter((c) => c.equipment_id.length > 0),
        );
        sections.push({
          isChecked: true,
          name: "Equipment Comments",
          fields: sectionFds2,
        });
      }

      //add Issues  section
      const sectionFdsx = getSectionFields(
        "issue",
        props.project.Issues.filter((i) => i.equipment_id.length > 0),
      );
      sections.push({ isChecked: true, name: "Issues", fields: sectionFdsx });

      //add checkLists  section
      const checkListsFds = getSectionFields(
        "checklist",
        props.project.Checklists.filter((i) => i.equipment_id.length > 0),
      );
      sections.push({
        isChecked: true,
        name: "Checklists",
        fields: checkListsFds,
      });
    } else if (props.exportTableName === "Observation") {
      //add Observation section
      const sectionFds = getSectionFields("observation", [props.observation]);
      sections.push({
        isChecked: true,
        name: "Observation",
        fields: sectionFds,
      });
      //add Observation Comments section
      if (
        project.Comments.filter((c) => c.observation_id.length > 0).length > 0
      ) {
        const sectionFds2 = getSectionFields(
          "comment",
          project.Comments.filter(
            (c) => c.issue_id.length > 0 || c.observation_id.length > 0,
          ),
        );
        sections.push({
          isChecked: true,
          name: "Observation Comments",
          fields: sectionFds2,
        });
      }

      //add Issues  section
      const sectionFdsx = getSectionFields(
        "issue",
        props.project.Issues.filter((i) => i.observation_id.length > 0),
      );
      sections.push({ isChecked: true, name: "Issues", fields: sectionFdsx });
      //add Issue Comments section
      if (
        project.Comments.filter((c) => c.observation_id.length > 0).length > 0
      ) {
        const sectionFds2 = getSectionFields(
          "comment",
          project.Comments.filter(
            (c) => c.issue_id.length > 0 || c.observation_id.length > 0,
          ),
        );
        sections.push({
          isChecked: true,
          name: "Issue Comments",
          fields: sectionFds2,
        });
      }
    }

    setExportDialogOpen(true);
    setReportSections(sections);
  };

  const handleTemplateNameChange = (e) => {
    const selectedTemplate = exportTemplates.find(
      (t) => t.name === e.target.value,
    );
    if (selectedTemplate) {
      setReportSections(selectedTemplate.sections);
    }
    setTemplateName(e.target.value);
    setNewTemplateName(e.target.value);
  };

  const onNewTemplateNameChange = (name) => {
    setNewTemplateName(name);
  };

  const onSaveTemplate = async () => {
    try {
      setIsLoading(true);
      const existing = project.ExportTemplates.find(
        (t) => t.name === newTemplateName,
      );
      if (!existing) {
        //save template logic here
        const newTemplate = {
          name: newTemplateName,
          type: props.exportTableName,
          sections: reportSections,
        };
        project.ExportTemplates.push(newTemplate);
        await saveToFirestore("projects", project);
        setExportTemplates([...exportTemplates, newTemplate]);
        setTemplateName(newTemplateName);
        enqueueSnackbar("Template saved successfully", {
          anchorOrigin: { vertical: "bottom", horizontal: "center" },
          variant: "success",
        });
      } else {
        existing.sections = reportSections;
        await saveToFirestore("projects", project);
        setExportTemplates([
          ...project.ExportTemplates.filter(
            (t) => t.type === props.exportTableName,
          ),
        ]);

        setTemplateName(newTemplateName);
        enqueueSnackbar(`Saved existing template: ${newTemplateName}`, {
          anchorOrigin: { vertical: "bottom", horizontal: "center" },
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Error saving template:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        variant: "error",
      });
    } finally {
      setIsLoading(false);
      // setExportDialogOpen(false);
    }
  };

  const handleCheckedSection = (sectionName, isChecked) => {
    const updatedSections = reportSections.map((section) => {
      if (section.name === sectionName) {
        console.log("section.name", section.name, "sectionName", sectionName);
        const updatedFields = section.fields.map((field) => ({
          ...field,
          checked: isChecked,
        }));
        section.isChecked = isChecked;
        return { ...section, fields: updatedFields };
      }
      return section;
    });

    setReportSections(updatedSections);
  };

  const handleChecked = (sectionName, fieldName, isChecked) => {
    const updatedSections = reportSections.map((section) => {
      if (section.name === sectionName) {
        const updatedFields = section.fields.map((field) => {
          if (field.name === fieldName) {
            return { ...field, checked: isChecked };
          }
          return field;
        });
        return { ...section, fields: updatedFields };
      }
      return section;
    });
    setReportSections(updatedSections);
  };

  const onMoveClick = (sectionName, fieldIndex, direction) => {
    const updatedSections = reportSections.map((section) => {
      if (section.name === sectionName) {
        const updatedFields = [...section.fields];
        const targetIndex = fieldIndex + direction;
        if (targetIndex >= 0 && targetIndex < updatedFields.length) {
          const temp = updatedFields[fieldIndex];
          updatedFields[fieldIndex] = updatedFields[targetIndex];
          updatedFields[targetIndex] = temp;
        }
        return { ...section, fields: updatedFields };
      }
      return section;
    });

    updatedSections.forEach((section) => {
      section.fields.map((fd, idx) => (fd.order = idx));
    });

    setReportSections([...updatedSections]);
  };

  const onExport = async () => {
    try {
      setIsLoading(true);
      if (props.exportTableName === "Issue") {
        await exportIssue(project, props.issue.id, reportSections);
      } else if (props.exportTableName === "Observation") {
        await exportObservation(project, props.observation.id, reportSections);
      } else if (props.exportTableName === "Equipment") {
        await exportEquipment(project, props.equipment.id, reportSections);
      } else if (props.exportTableName === "Checklist") {
        await exportChecklist(project, props.checklist.id, reportSections);
      }
    } catch (error) {
      console.error("Error exporting:", error);
      enqueueSnackbar(
        error.hasOwnProperty("message")
          ? "Export failed:" + error.message
          : "Export failed",
        {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "error",
        },
      );
    } finally {
      setIsLoading(false);
      setExportDialogOpen(false);
    }
  };

  return isLoading ? (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : (
    <div>
      <Tooltip title={`Export ${props.exportTableName} as PDF`}>
        <IconButton
          onClick={onExportClick}
          aria-label={`Export ${props.exportTableName} as PDF`}
          size="large"
          color="primary"
        >
          <PictureAsPdfIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>

      <ExportDialog
        isOpen={exportDialogOpen}
        onClose={onCloseExportDialog}
        onExportFeatures={onExport}
        templateName={templateName}
        newTemplateName={newTemplateName}
        exportTemplates={exportTemplates}
        handleTemplateNameChange={handleTemplateNameChange}
        onNewTemplateNameChange={onNewTemplateNameChange}
        onSaveTemplate={onSaveTemplate}
        reportSections={reportSections}
        handleChecked={handleChecked}
        handleCheckedSection={handleCheckedSection}
        onMoveClick={onMoveClick}
      />
    </div>
  );
}
